export default __webpack_public_path__ + "static/media/cafe-icon.b6c17ff5.svg";